// Product

class Product {
  constructor() {
    this.pageScroll();
  }

  pageScroll() {
    var doc = document.documentElement;
    var w = window;

    var prevScroll = w.scrollY || doc.scrollTop;
    var curScroll;
    var direction = 0;
    var prevDirection = 0;

    var title = document.querySelector('.product__scroll');

    var checkScroll = function() {

      /*
      ** Find the direction of scroll
      ** 0 - initial, 1 - up, 2 - down
      */

      curScroll = w.scrollY || doc.scrollTop;
      if (curScroll > prevScroll) { 
        //scrolled up
        direction = 2;
      }
      else if (curScroll < prevScroll) { 
        //scrolled down
        direction = 1;
      }

      if (direction !== prevDirection) {
        toggleTitle(direction, curScroll);
      }
      
      prevScroll = curScroll;
      var metaScroll = document.querySelector('.product__meta').offsetTop - curScroll;

      if (metaScroll <= 98) {
        title.classList.add('scrolling')
      } else {
        title.classList.remove('scrolling')
      }
    };

    var toggleTitle = function(direction, curScroll) {
      if (direction === 2 && curScroll > 50) { 
        
        //replace 50 with the height of your title in px

        title.classList.add('hidden');
        prevDirection = direction;
      }
      else if (direction === 1 && curScroll <= 0) {
        title.classList.remove('hidden');
        prevDirection = direction;
      }
    };
    
    window.addEventListener('scroll', checkScroll);
  }
}

const productInit = {
  init() {
    // if element exists init this class
    const productElem = [].slice.call(
      document.querySelectorAll('.product')
    );
    if (productElem.length > 0) {
      const productWrap = new Product();
    }
  },
};

export default productInit;
